import { faArrowsRepeat, faBlockQuote, faGridDividers, faGroupArrowsRotate } from '@fortawesome/pro-light-svg-icons';

import { BlockType } from '@empathy/survey/base';

import { BlockTypeConfig } from './block-type-config.interface';

// Display metadata covers every kind; the picker controls which kinds can be authored.
export const BlockTypeIconConfig: Record<BlockType, BlockTypeConfig> = {
  [BlockType.MultiBlock]: {
    type: BlockType.MultiBlock,
    text: 'Multi-Block',
    icon: faGridDividers
  },
  [BlockType.Group]: {
    type: BlockType.Group,
    text: 'Single-Block',
    icon: faBlockQuote
  },
  [BlockType.LoopParent]: { type: BlockType.LoopParent, text: 'Loop Parent', icon: faGroupArrowsRotate },
  [BlockType.Loop]: { type: BlockType.Loop, text: 'Loop Questions', icon: faArrowsRepeat }
};
